import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HttpHeadersPortal, HttpService } from './../../http/http.service';
import { ICity } from './../../models/city/icity';
import { IDepartament } from './../../models/departament/idepartament';
import { GeneralResponse } from './../../models/general-response/general-response';
import { LocalStorageService } from './../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public minimum_salary: number = 0;
  private tareaDeVerificadorDeVersion: ReturnType<typeof setTimeout>;

  constructor(
    private _storage: LocalStorageService,
    private _http: HttpService
    ) { }

  public getToken(): any {
    return this._storage.getItemString(environment.LOCAL_STORAGE.LOGIN_USER_TOKEN);
  }

  public calculerDV(nit: string) {
    let arr; let x; let y; let z; let i; let cod;

    arr = new Array(16);
    x = 0; y = 0; z = nit.length;
    arr[1] = 3; arr[2] = 7; arr[3] = 13;
    arr[4] = 17; arr[5] = 19; arr[6] = 23;
    arr[7] = 29; arr[8] = 37; arr[9] = 41;
    arr[10] = 43; arr[11] = 47; arr[12] = 53;
    arr[13] = 59; arr[14] = 67; arr[15] = 71;

    for (i = 0; i < z; i++) {
      y = (nit.slice(i, i + 1));
      x += (y * arr[z - i]);
    }
    y = x % 11;

    if (y > 1) { cod = 11 - y; } else { cod = y; }

    return cod;

  }

  getCountries(): Observable<any> {
    return this._http.get(
      environment.AFILIACION_MASIVA.API_URL,
      '/getCountryDepartaments'
    ).pipe(
      map((response) => {
        return response;
      })
    );

  }

  getCities(departament: IDepartament): Observable<GeneralResponse<ICity[]>> {
    const params = {
      departament: departament.department_CODE
    };

    return this._http.get<GeneralResponse<ICity[]>>(
      environment.AFILIACION_MASIVA.API_URL,
      '/getMunicipality',
      params
    ).pipe(
      map((response) => {
        return response;
      })
    );

  }

  validateAddress(address: string): Observable<GeneralResponse<any>> {
    const params = {
      address: address.toString()
    };

    return this._http.get(
      environment.AFILIACION_MASIVA.API_URL,
      '/validateAddress',
      params
    ).pipe(
      map((response) => {
        return response as GeneralResponse<any>;
      })
    );
  }

  formatoDANE(direccion: string): Observable<GeneralResponse<any>>{
    const params = {
      direccion: direccion.toString()
    };

    return this._http.get(
      environment.AFILIACION_MASIVA.API_URL,
      '/address',
      params
    )
  }

  getSalarioMinimo() {
    if (!this.minimum_salary || this.minimum_salary == 0) {
          let url = `${environment.GESTOR_DE_CONTENIDO_URL}`;
          let SALARIO_MINIMO = `${environment.SALARIO_MINIMO}`;

          this._http.get<Array<any>>(
            url,
            '/configuraciones'
          ).pipe(
            map((response) => {
              let configuracion = response.find((p) =>
                p.field_type.includes("SMMV")
              );

              if(configuracion && configuracion.field_valor && configuracion.field_valor > 0){
                 this.minimum_salary = configuracion.field_valor;
                 this._storage.setItem("minimum_salary", configuracion.field_valor);
              }
              else{

                this._storage.setItem("minimum_salary", SALARIO_MINIMO);
              }
            }),

            catchError((err) => {
              console.log('error caught in service:'+err.message)
              this._storage.setItem("minimum_salary", SALARIO_MINIMO);
              return throwError(() => err);
            })
          ).subscribe();
     }
  }

  getVersion() {
    const url = environment.VERSION_URL;
    const headers: HttpHeadersPortal = {
      COMPILAR_SIN_HEADERS_GLOBALES: 'true'
    }

    const customOptions = {responseType: 'text'}

    return this._http.get<string>(
      url,
      '',
      {},
      headers,
      customOptions
    ).pipe(
      map((version: string) => ({ version }))
    );
  }

  validarVersion() {
    const esEntornoDeDesarrollo = (environment.VERSION === 'local-dev');
    if (esEntornoDeDesarrollo)
      return;

    this.detenerTemporizador(this.tareaDeVerificadorDeVersion);

    this.getVersion().subscribe((serverVersion) => {
      console.log('getVersion: ', environment.VERSION, 'server: ', serverVersion.version);
      const esVersionDeAppActualizada = (serverVersion.version === environment.VERSION);
      if (esVersionDeAppActualizada)
        return;

      if (confirm('Hay una nueva versión disponible. ¿Desea recargar la página?')) {
        window.location.reload();
      } else {
        const unaHoraEnMiliSegundos = 3600000;
        this.tareaDeVerificadorDeVersion = this.establecerTemporizador(this.validarVersion.bind(this), unaHoraEnMiliSegundos);
      }
    });
  }

  establecerTemporizador(callback: (...args: any[]) => void, delay: number, ...args: any[]): ReturnType<typeof setTimeout> {
    return setTimeout(() => callback(...args), delay);
  }

  detenerTemporizador(temporizador) {
    const hayTemporizadorActivo = (temporizador != null);
    if (!hayTemporizadorActivo)
      return;

    clearTimeout(temporizador);
    temporizador = null;
  }
}
